// extracted by mini-css-extract-plugin
module.exports = {"video-modal":"index_video-modal__HU0Jf","download-btn":"index_download-btn__g_07d"};